//# sourceMappingURL=content_library.mjs.map
/// <reference types="./content_library.d.mts" />
import * as $ask from "../../../altar/altar/ask.mjs";
import * as $data_source from "../../../data_types/data/data_source.mjs";
import * as $page from "../../../data_types/data/page.mjs";
import * as $http from "../../../gleam_http/gleam/http.mjs";
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $dynamic from "../../../gleam_stdlib/gleam/dynamic.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $int from "../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $effect from "../../../redraw_lustre/redraw/lustre/effect.mjs";
import * as $toast from "../../../redraw_toastify/toastify/toast.mjs";
import * as $super_admin from "../../admin/effects/super_admin.mjs";
import { apply_org_header } from "../../admin/effects/super_admin.mjs";
import * as $middleware from "../../admin/middleware.mjs";
import * as $content_library from "../../data/content_library.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $store from "../../data/store.mjs";
import { toList } from "../../gleam.mjs";

function add_pagination_query(query, qna_page, non_qna_page) {
  let _pipe = toList([
    ["page", non_qna_page.page_index],
    ["non_qna_page", non_qna_page.page_index],
    ["qna_page", qna_page.page_index],
    ["page_size", qna_page.page_size],
  ]);
  return $list.fold(
    _pipe,
    query,
    (query, filter) => {
      let name = filter[0];
      let value = filter[1];
      let value$1 = $int.to_string(value);
      return $ask.query(query, name, value$1);
    },
  );
}

export function fetch_content_library() {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(
            new $ask.Heimdall(),
            toList(["admin", "content-library"]),
          );
          let _pipe$1 = $ask.bearing(_pipe, access_token);
          let _pipe$2 = apply_org_header(_pipe$1, store);
          let _pipe$3 = add_pagination_query(
            _pipe$2,
            $page.max_page,
            $page.max_page,
          );
          let _pipe$4 = $ask.expect(
            _pipe$3,
            (() => {
              let decoder = $page.page_decoder(
                $decode.list($data_source.decoder()),
              );
              return $decode.field(
                "sources",
                decoder,
                (sources) => {
                  return $decode.field(
                    "questions",
                    decoder,
                    (questions) => {
                      return $decode.field(
                        "proposals",
                        decoder,
                        (proposals) => {
                          return $decode.success(
                            $list.flatten(
                              toList([
                                sources.elements,
                                questions.elements,
                                proposals.elements,
                              ]),
                            ),
                          );
                        },
                      );
                    },
                  );
                },
              );
            })(),
          );
          let _pipe$5 = $ask.on_success(
            _pipe$4,
            (d) => {
              let _pipe$5 = new $msg.ApiReturnedSources(d);
              let _pipe$6 = new $msg.ContentLibrary(_pipe$5);
              return dispatch(_pipe$6);
            },
          );
          let _pipe$6 = $ask.on_error(
            _pipe$5,
            (_) => {
              let _pipe$6 = new $msg.ApplicationRequestedToDisplayToast(
                new $toast.Error(),
                "Failed to load content library sources",
              );
              return dispatch(_pipe$6);
            },
          );
          return $ask.run(_pipe$6);
        },
      );
    },
  );
}

export function update_data_sources_status(status) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      let data_sources = $content_library.extract_selected_source_ids(
        store.content_library.selected,
      );
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let at = toList(["content-library"]);
          let _pipe = $ask.to(new $ask.Heimdall(), at);
          let _pipe$1 = $ask.bearing(_pipe, access_token);
          let _pipe$2 = apply_org_header(_pipe$1, store);
          let _pipe$3 = $ask.via(_pipe$2, new $http.Patch());
          let _pipe$4 = $ask.expect(
            _pipe$3,
            $decode.list($data_source.decoder()),
          );
          let _pipe$5 = $ask.with$(
            _pipe$4,
            $json.object(
              toList([
                ["status", $json.string($data_source.status_to_string(status))],
                ["data_source_ids", $json.array(data_sources, $json.string)],
              ]),
            ),
          );
          let _pipe$6 = $ask.on_success(
            _pipe$5,
            (sources) => {
              let _pipe$6 = sources;
              $list.map(
                _pipe$6,
                (s) => {
                  let _pipe$7 = new $msg.ApiReturnedSource(s);
                  let _pipe$8 = new $msg.ContentLibrary(_pipe$7);
                  return dispatch(_pipe$8);
                },
              );
              let _pipe$7 = new $msg.ApplicationRequestedToDisplayToast(
                new $toast.Success(),
                "Sources modified",
              );
              return dispatch(_pipe$7);
            },
          );
          let _pipe$7 = $ask.on_error(
            _pipe$6,
            (_) => {
              let _pipe$7 = new $msg.ApplicationRequestedToDisplayToast(
                new $toast.Error(),
                "Sources not modified",
              );
              return dispatch(_pipe$7);
            },
          );
          return $ask.run(_pipe$7);
        },
      );
    },
  );
}
